import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';

/**
 * קומפוננטה להצגת ועריכת הודעה מהחנות.
 */
const TextBox = ({ effectiveUserId, isEditMode, storeMessage, backgroundColor }) => {
  const [message, setMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    setMessage(storeMessage || '');
  }, [storeMessage]);

  const handleSave = async () => {
    if (!effectiveUserId) return;
    setIsSaving(true);
    setFeedback('');
    try {
      const settingsRef = doc(db, 'users', effectiveUserId, 'settings', 'main');
      await setDoc(settingsRef, { storeMessage: message }, { merge: true });
      setFeedback('ההודעה נשמרה בהצלחה!');
    } catch (error) {
      console.error("Error saving store message:", error);
      setFeedback('שגיאה בשמירת ההודעה.');
    } finally {
      setIsSaving(false);
      setTimeout(() => setFeedback(''), 3000);
    }
  };

  // --- לוגיקת צבעים חדשה וישירה ---
  const isLightTheme = backgroundColor === 'bg-white';
  const textColor = isLightTheme ? 'text-black' : 'text-white';
  const borderColor = isLightTheme ? 'border-gray-400' : 'border-gray-600';
  const placeholderColor = isLightTheme ? 'placeholder-gray-600' : 'placeholder-gray-400';
  const titleColor = isLightTheme ? 'text-amber-700' : 'text-amber-400';
  const feedbackColor = isLightTheme ? 'text-green-600' : 'text-green-400';

  if (!isEditMode) {
    if (!message) return null;
    return (
      <div className="w-11/12 max-w-2xl mx-auto bg-transparent p-4 my-6 text-center">
        <p className={`whitespace-pre-wrap ${textColor}`} style={{ fontFamily: 'Calibri, sans-serif', fontSize: '25px' }}>
          {message}
        </p>
      </div>
    );
  }

  return (
    <div className="w-11/12 max-w-2xl mx-auto bg-transparent p-4 my-6 text-center">
      <p className={`text-lg font-semibold mb-3 ${titleColor}`}>עריכת הודעה לבית העסק</p>
      <textarea
        className={`w-full h-24 p-2 bg-transparent border-b ${borderColor} ${textColor} ${placeholderColor} focus:ring-0 focus:border-amber-500 transition-colors duration-200 text-center`}
        style={{ fontFamily: 'Calibri, sans-serif', fontSize: '25px' }}
        placeholder="כתוב כאן הודעה שתוצג ללקוחות..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        disabled={isSaving}
      />
      <button
        onClick={handleSave}
        className="mt-3 w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg transition-colors duration-200 disabled:bg-gray-500"
        disabled={isSaving}
      >
        {isSaving ? 'שומר...' : 'שמור הודעה'}
      </button>
      {feedback && <p className={`text-sm mt-2 ${feedback.includes('שגיאה') ? 'text-red-400' : feedbackColor}`}>{feedback}</p>}
    </div>
  );
};

export default TextBox;